import { render, staticRenderFns } from "./CreateCommunication.vue?vue&type=template&id=164eea1c"
import script from "./CreateCommunication.vue?vue&type=script&lang=js"
export * from "./CreateCommunication.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateCommunication.vue?vue&type=style&index=1&id=164eea1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports